import { render, staticRenderFns } from "./UploadBankLogoForm.vue?vue&type=template&id=f4185b66&scoped=true&"
import script from "./UploadBankLogoForm.vue?vue&type=script&lang=js&"
export * from "./UploadBankLogoForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadBankLogoForm.vue?vue&type=style&index=0&id=f4185b66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4185b66",
  null
  
)

export default component.exports